import { IconButton, SvgIcon } from '@mui/material';
import { createContext, useContext, useEffect, useState } from 'react';
import { listReportCategories } from '../api/reports';
import {
  ICategory,
  IReportsContext,
  ISelectedReportsData,
} from '../types/reports';
import { useProgramData } from './ProgramDataProvider';

export const CatalogType = {
  report_catalog: {
    title: 'Report Catalog',
    subTitle: 'Flexible Reports at ease',
  },
  schedules: {
    title: 'Schedules',
    subTitle: 'Flexible Reports at ease',
  },
};
export const ReportCatalogCategories: Record<string, ICategory> = {
  'c254b926-3f6e-4165-a044-98bb3587a355': {
    categoryId: 'c254b926-3f6e-4165-a044-98bb3587a355',
    reportCategory: 'Lending',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    color: 'red',
    status: '3 Reports',
    Icon: () => (
      <IconButton sx={{ background: '#D4E8FF' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
              stroke="#5F5F5F"
              stroke-width="2.0625"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M5.5 9.5V14.5M18.5 9.5V14.5M12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15V15Z"
              stroke="#5F5F5F"
              stroke-width="2.0625"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
  'f49510b4-f09c-4987-963b-5257fd2d5142': {
    categoryId: 'f49510b4-f09c-4987-963b-5257fd2d5142',
    reportCategory: 'Collections',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    color: 'red',
    status: '3 Reports',
    Icon: () => (
      <IconButton sx={{ bgcolor: '#FFC8E9' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 5.4897V20.4897M7.75 8.4897H5.5M8.5 11.4897H5.5M22 16.7397V4.6697C22 3.4697 21.02 2.5797 19.83 2.6797H19.77C17.67 2.8597 14.48 3.9297 12.7 5.0497L12.53 5.1597C12.24 5.3397 11.76 5.3397 11.47 5.1597L11.22 5.0097C9.44 3.8997 6.26 2.8397 4.16 2.6697C2.97 2.5697 2 3.4697 2 4.6597V16.7397C2 17.6997 2.78 18.5997 3.74 18.7197L4.03 18.7597C6.2 19.0497 9.55 20.1497 11.47 21.1997L11.51 21.2197C11.78 21.3697 12.21 21.3697 12.47 21.2197C14.39 20.1597 17.75 19.0497 19.93 18.7597L20.26 18.7197C21.22 18.5997 22 17.6997 22 16.7397V16.7397Z"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
  '979f9e91-cc6d-4d4c-ac69-1d637e790b1e': {
    categoryId: '979f9e91-cc6d-4d4c-ac69-1d637e790b1e',
    reportCategory: 'CMS',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    status: '2 Reports',
    color: 'red',
    Icon: () => (
      <IconButton sx={{ bgcolor: '#FFD9C8' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18.1404 21.6197C17.2604 21.8797 16.2204 21.9997 15.0004 21.9997H9.00035C7.78035 21.9997 6.74035 21.8797 5.86035 21.6197C6.08035 19.0197 8.75035 16.9697 12.0004 16.9697C15.2504 16.9697 17.9204 19.0197 18.1404 21.6197V21.6197Z"
              stroke="#414141"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15 2H9C4 2 2 4 2 9V15C2 18.78 3.14 20.85 5.86 21.62C6.08 19.02 8.75 16.97 12 16.97C15.25 16.97 17.92 19.02 18.14 21.62C20.86 20.85 22 18.78 22 15V9C22 4 20 2 15 2ZM12 14.17C10.02 14.17 8.42 12.56 8.42 10.58C8.42 8.6 10.02 7 12 7C13.98 7 15.58 8.6 15.58 10.58C15.58 12.56 13.98 14.17 12 14.17Z"
              stroke="#414141"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M15.5799 10.58C15.5799 12.56 13.9799 14.17 11.9999 14.17C10.0199 14.17 8.41992 12.56 8.41992 10.58C8.41992 8.6 10.0199 7 11.9999 7C13.9799 7 15.5799 8.6 15.5799 10.58Z"
              stroke="#414141"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
};

export const ScheduleCategories: Record<string, ICategory> = {
  schedules: {
    categoryId: 'schedules',
    reportCategory: 'Schedules',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    color: 'red',
    status: '3 Reports',
    Icon: () => (
      <IconButton sx={{ background: '#D4E8FF' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 8V13M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9 2H15"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
  past_reports: {
    categoryId: 'past_reports',
    reportCategory: 'Past Reports',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    color: 'red',
    status: '3 Reports',
    Icon: () => (
      <IconButton sx={{ background: '#FFC8E9' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M8 7H16M8 10.5H13M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
  custom_metrics: {
    categoryId: 'custom_metrics',
    reportCategory: 'Custom Metrics',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    status: 'Coming Soon',
    color: 'red',

    Icon: () => (
      <IconButton sx={{ background: '#FFD9C8' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1.99609 8.5H11.4961M5.99609 16.5H7.99609M10.4961 16.5H14.4961"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M21.9961 12.03V16.11C21.9961 19.62 21.1061 20.5 17.5561 20.5H6.43609C2.88609 20.5 1.99609 19.62 1.99609 16.11V7.89C1.99609 4.38 2.88609 3.5 6.43609 3.5H14.4961"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M19.0764 4.13031L15.3664 7.84031C15.2264 7.98031 15.0864 8.26031 15.0564 8.46031L14.8564 9.88031C14.7864 10.3903 15.1464 10.7503 15.6564 10.6803L17.0764 10.4803C17.2764 10.4503 17.5564 10.3103 17.6964 10.1703L21.4064 6.46031C22.0464 5.82031 22.3464 5.08031 21.4064 4.14031C20.4564 3.19031 19.7164 3.49031 19.0764 4.13031V4.13031Z"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M18.5459 4.66016C18.8659 5.79016 19.7459 6.67016 20.8659 6.98016"
              stroke="#5F5F5F"
              stroke-width="1.5"
              stroke-miterlimit="10"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
  custom_attributes: {
    categoryId: 'custom_attributes',
    reportCategory: 'Custom Attributes ',
    programId: '7329071d-4352-4c81-840b-b8ffe50c9371',
    status: 'Coming Soon',
    color: 'red',

    Icon: () => (
      <IconButton sx={{ background: '#C3FFCE' }}>
        <SvgIcon>
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 12H16M12 16V8M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
              stroke="#414141"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </SvgIcon>
      </IconButton>
    ),
  },
};

export const ReportsContext = createContext<IReportsContext | null>(null);

export const useReports = () => useContext(ReportsContext) as IReportsContext;

export const ReportsProvider = (props: any) => {
  const [reportCategories, setReportCategories] = useState<
    Record<string, ICategory>
  >({});

  const [selectedReportsData, setSelectedReportsData] =
    useState<ISelectedReportsData>({
      selectedCatalogType: 'report_catalog',
      selectedCategoryId: 'lending',
      selectedReportId: '',
      selectedReportConfigId: '',
    });

  const { selectedProgram } = useProgramData();

  const updateCatalogCategories = (catalogType: string) => {
    let currentCategories: ICategory[] = [];

    if (catalogType === 'report_catalog') {
      // fetch catalogs
      // currentCategories = ReportCatalogCategories;
      // satitic program id for now
      // const programId = '7329071d-4352-4c81-840b-b8ffe50c9371s';
      // if (programId) {
      //   listReportCategories(programId)
      //     .then((res) => {
      //       console.log(
      //         ' listReportCategories fetched reportcategories',
      //         res.data
      //       );

      //       currentCategories = res.data;
      //       console.log(
      //         'listReportCategories currentCategories',
      //         currentCategories
      //       );
      //       const finalCategories = currentCategories?.reduce((pre, curr) => {
      //         return {
      //           ...pre,
      //           [curr.categoryId]: curr,
      //         };
      //       }, {} as Record<string, ICategory>);

      //       console.log(
      //         'listReportCategories fianlcategories ',
      //         finalCategories
      //       );
      //       if (finalCategories) setReportCategories(finalCategories);
      //       if (currentCategories.length)
      //         updateSelectedReportsData(
      //           'selectedCategoryId',
      //           currentCategories[0].categoryId
      //         );
      //     })
      //     .catch((err) => {
      //       console.log('listReportCategories  err');
      //     });
      // }

      setReportCategories(ReportCatalogCategories);
      updateSelectedReportsData(
        'selectedCategoryId',
        ReportCatalogCategories['c254b926-3f6e-4165-a044-98bb3587a355']
          .categoryId
      );
    } else {
      setReportCategories(ScheduleCategories);
      updateSelectedReportsData(
        'selectedCategoryId',
        ScheduleCategories['schedules'].categoryId
      );
    }
  };

  const updateSelectedReportsData = (
    key: keyof ISelectedReportsData,
    value: string
  ) => {
    setSelectedReportsData((pre) => {
      return {
        ...pre,
        [key]: value,
      };
    });
  };

  useEffect(() => {
    updateCatalogCategories(selectedReportsData.selectedCatalogType);
  }, [selectedReportsData.selectedCatalogType]);

  return (
    <ReportsContext.Provider
      value={{
        reportCategories,
        ...selectedReportsData,
        setSelectedReportsData,

        updateSelectedReportsData,
      }}
    >
      {props.children}
    </ReportsContext.Provider>
  );
};
